import { render, staticRenderFns } from "./comfirm_modal.vue?vue&type=template&id=e2c126b8&scoped=true"
import script from "./comfirm_modal.vue?vue&type=script&lang=js"
export * from "./comfirm_modal.vue?vue&type=script&lang=js"
import style0 from "./comfirm_modal.vue?vue&type=style&index=0&id=e2c126b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c126b8",
  null
  
)

export default component.exports